import { useTranslation } from 'react-i18next'
import moment from 'moment'
import "./style.css"
import PricingItem from '../PricingItems';
import BillList from '../BillList';
import { STATUS_MAP } from '@/data/status';
import { useMemo } from 'react';


const shownItems = (quotationData, sPS, sAddOns) => ({
    postServices: quotationData?.postServices?.filter(item => sPS.includes(item.id)) || [],
    addOns: quotationData?.addOns?.filter(item => sAddOns.includes(item.id)) || [],
})

const QuotationInvoice = ({ quotationData, selectedAddOns, selectedPostServices }) => {
    const { t } = useTranslation();
    console.log("selectedAddons", selectedAddOns)
    console.log("selected post services", selectedPostServices)

      const { postServices, addOns } = shownItems(quotationData, selectedPostServices, selectedAddOns);
    
        const totalPostServices = useMemo(() => postServices?.reduce((sum, ps) => sum + ps.price, 0), [postServices]);
    
        const totalPrice = useMemo(() => {
    
            let totalPaidAddOns = addOns?.reduce((sum, addon) => sum + addon.price, 0) || 0;
            let totalPaidPostServices = postServices?.reduce((sum, ps) => sum + ps.price, 0) || 0;
    
            return Number(quotationData?.totalPrice) + Number(totalPaidAddOns) + Number(totalPaidPostServices);
        }, [quotationData, addOns, postServices]);
    
        const ShownAmountToPay = useMemo(() => {
            
            if (![STATUS_MAP.RequestSubmitted, STATUS_MAP.QuotationAvailable, STATUS_MAP.AwaitingInitialPayment, STATUS_MAP.RequestClosed].includes(quotationData?.orderStatusId)) {
               console.log("1",quotationData?.pendingPaymentAmount, totalPostServices);
                return Math.ceil(quotationData?.pendingPaymentAmount + Number(totalPostServices));
            }
            if (STATUS_MAP.AwaitingInitialPayment == quotationData?.orderStatusId) {
                console.log("2",quotationData?.totalPrice, Number(parseInt(quotationData?.paymentPercentage)));
                return Math.ceil(Number(quotationData?.totalPrice) * (Number(parseInt(quotationData?.paymentPercentage)) / 100));
            }
            if(STATUS_MAP.QuotationAvailable == quotationData?.orderStatusId){
                console.log("3",totalPrice, quotationData?.paymentPercentage);
                return Math.ceil((Number(totalPrice)) * (Number(quotationData?.paymentPercentage) / 100));
            }
    
        }, [quotationData, totalPostServices , totalPrice, quotationData?.paymentPercentage])
    
    
    const activeAddOns = quotationData?.addOns?.filter(item => selectedAddOns.includes(item.id) || item.isSelected) || [];
    const addonsPrice = activeAddOns.reduce((a, i) => a + i.price, 0);

    const activePostServices = quotationData?.postServices?.filter(item => selectedPostServices.includes(item.id) || item.isSelected) || [];
    const postServicesPrice = activePostServices.reduce((s,i)=>s+i.price,0);


    const amountDue = totalPrice - Number(quotationData?.paidPrice || 0);

    return (
        <div className="qd-invoice-card">
            <div className="qd-invoice-header">
                <h1 className="qd-invoice-title">{t("Invoice")}</h1>
                <div className="qd-invoice-meta">
                    <div className="qd-inv-meta-row"><span>{t("Invoice number")}</span> <strong>{quotationData?.orderId}</strong></div>
                    <div className="qd-inv-meta-row"><span>{t("Date of issue")}</span> <strong>{moment().format("MMMM DD, YYYY")}</strong></div>
                    <div className="qd-inv-meta-row"><span>{t("Date due")}</span> <strong>{moment(quotationData?.availableToDate).format("MMMM DD, YYYY")}</strong></div>
                </div>
            </div>

            <div className="qd-invoice-parties">
                <div className="qd-inv-party">
                    <h3>{t("Bill from")}</h3>
                    <p><strong>{quotationData?.providerName}</strong></p>
                </div>
            </div>

            <div className="qd-invoice-highlight">
                <h2>{t("total value")} {totalPrice?.toLocaleString()} $</h2>
                <p>{t("Quotation for")} {quotationData?.serviceName}</p>
            </div>

            <table className="qd-invoice-table">
                <thead>
                    <tr>
                        <th className="text-start">{t("Description")}</th>
                        <th className="text-center">{t("Qty")}</th>
                        <th className="text-center">{t("Unit price")}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{t("Base Quotation Cost")} ({quotationData?.serviceName})</td>
                        <td className="text-center">1</td>
                        <td className="text-end">{quotationData?.price?.toLocaleString()} $</td>
                    </tr>
                    {activeAddOns.map(item => (
                        <tr key={item.id}>
                            <td>{item.name} <strong>({t("Add-on")})</strong></td>
                            <td className="text-center">1</td>
                            <td className="text-end">{item.price?.toLocaleString()} $</td>
                        </tr>
                    ))}
                    {activePostServices.map(item => (
                        <tr key={item.id}>
                            <td>{item.name} <strong>({t("Post Service")})</strong></td>
                            <td className="text-center">1</td>
                            <td className="text-end">{item.price?.toLocaleString()} $</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div className="qd-invoice-footer">
                <div className="qd-inv-summary">
                    <div className="qd-inv-summary-row"><span>{t("Base Quotation Cost")}</span> <span>{quotationData?.price?.toLocaleString()} $</span></div>
                    <PricingItem title={"Add-ons"} isRender={!!quotationData?.addsOnPrice} price={quotationData?.addsOnPrice} detailsList={quotationData?.addOns?.filter(item => !!item.isSelected)} />
                    <BillList title={"submited-add-ons"} List={addOns} />
                    <PricingItem title={"-postServices"} detailsList={quotationData?.postServices?.filter(item => !!item.isSelected)} isRender={!!quotationData?.postServicePrice} price={quotationData?.postServicePrice} />
                    <BillList title={"submited-postServices"} List={postServices} />
                    <div className="qd-inv-summary-row border-top"><span>{t("Total")}</span> <span>{totalPrice?.toLocaleString()} $</span></div>
                    <div className="qd-inv-summary-row"><span>{t("Paid Price")}</span> <span>{quotationData?.paidPrice?.toLocaleString()} $</span></div>
                    {amountDue>0 && <div className="qd-inv-summary-row highlighted"><span>{t("Amount due")}</span> <strong>{amountDue?.toLocaleString()} $</strong></div>}              
              </div>
            </div>

            <div className="qd-invoice-bottom-notices">
                <p><strong>{quotationData?.providerName}</strong></p>
            </div>
        </div>
    );
};

export default QuotationInvoice